<template>
  <div
    class="relative bg-cover bg-center"
    :class="[
      styles.containerClass,
      $style.backgroundImage,
      customBackgroundImageClass,
    ]"
  >
    <!-- overlay -->
    <div
      v-if="styles.hasOverlay"
      class="absolute"
      :class="[styles.overlayClass, customOverlayClass]"
    />

    <div
      class="text-static-default-hi relative flex flex-col items-center justify-center"
      :class="[styles.moodClass, containerClass]"
    >
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { tw } from '@backmarket/utils/string/tw'

import type { BackgroundProps } from './Background.types'
import { getBackgroundStyles } from './Background.utils'

const props = defineProps<
  BackgroundProps & {
    containerClass?: string
    customOverlayClass?: string
    customBackgroundImageClass?: string
  }
>()

const styles = computed(() => getBackgroundStyles(props))

const customOverlayClass = computed(() => {
  if (props.customOverlayClass) return props.customOverlayClass

  return tw`bg-surface-default-low bottom-0 left-0 right-0 top-0 opacity-40`
})

const customBackgroundImageClass = computed(() => {
  if (props.customBackgroundImageClass) return props.customBackgroundImageClass

  return tw`bg-cover bg-center`
})
</script>

<style module>
.backgroundImage {
  background-image: v-bind(styles.backgroundImage.mobile);

  @media (min-width: theme('screens.md')) {
    background-image: v-bind(styles.backgroundImage.desktop);
  }
}
</style>
